/* eslint-disable no-alert */
/* eslint-disable no-restricted-globals */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Card, CardBody, CardHeader, Modal, ModalBody,
  ModalHeader, ModalFooter, Button,
} from 'reactstrap';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import FamilyForm from '../../components/Fuse/FamilyForm';
import PropertyForm from '../../components/Fuse/PropertyForm';
import BaseGrid from '../../components/Common/BaseGrid';
import { Can } from '../../utilities/Can';
import { del, get, post } from '../../helpers/api_helper';
import MassUpdateForm from '../../components/Fuse/MassUpdateForm';

function createPropertyMemberValueSelect(args) {
  const {
    choices,
    member,
    onChange,
    t,
    value,
  } = args;
  const canEdit = member.item?.id && choices.length > 0;

  return React.createElement(
    'select',
    {
      className: 'form-control form-control-sm',
      defaultValue: value ?? '',
      disabled: !canEdit,
      onChange: (e) => onChange(member, e.target.value),
    },
    [
      React.createElement('option', { key: '', value: '' }, t('Choose...')),
      ...choices.map((choice) => (
        React.createElement('option', { key: choice, value: choice }, choice)
      )),
    ],
  );
}

function Fuse(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const { t } = props;

  const [createModal, setCreateModal] = useState(false);
  const [editEntity, setEditEntity] = useState(null);

  const [createPropModal, setCreatePropModal] = useState(false);
  const [showMembersModal, setShowMembersModal] = useState(false);
  const [massModal, setMassModal] = useState(false);
  const [editProp, setEditProp] = useState(null);

  const [signal, setSignal] = useState(1);

  const deleteFamily = async (family) => {
    try {
      if (confirm(t('Are you sure?'))) {
        await del(`/api/fuse/family/${family.id}`);

        setSignal(signal + 1);
        toastr.success(`${family.name} deleted!`, t('Success'));
      }
    } catch (error) {
      toastr.error(error.message, t('Error while deleting'));
    }
  };

  const deleteProp = async (prop) => {
    try {
      if (confirm(t('Are you sure?'))) {
        await del(`/api/fuse/property/${prop.id}`);

        setSignal(signal + 1);
        toastr.success(`${prop.label} deleted!`, t('Success'));
      }
    } catch (error) {
      toastr.error(error.message, t('Error while deleting'));
    }
  };

  const deriveQtys = async () => {
    try {
      await get('/api/fuse/family/derive');

      setSignal(signal + 1);
      toastr.success('Qtys derived!', t('Success'));
    } catch (error) {
      toastr.error(error.message, t('Error while deriving qty'));
    }
  };

  const getPropertyChoices = (prop) => {
    if (!prop?.choices) return [];

    try {
      const choices = Array.isArray(prop.choices) ? prop.choices : JSON.parse(prop.choices);

      return choices.map((choice) => `${choice}`.trim()).filter(Boolean);
    } catch (error) {
      toastr.error(error.message, t('Error while loading property choices'));
      return [];
    }
  };

  const setMemberProperty = async (member, value) => {
    try {
      await post(`/api/fuse/property/item/${member.item_id}/${editProp.id}`, { value });

      setSignal(signal + 1);
      toastr.success('Property updated!', t('Success'));
    } catch (error) {
      toastr.error(error.message, t('Error setting Fuse property'));
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col xxl="6">
            <Card>
              <CardHeader className="bg-transparent border-bottom">
                {t('Families')}
              </CardHeader>
              <CardBody>
                <Can i="see" this="Fuse">
                  <Button color="primary" className="mb-3" size="sm" onClick={() => { deriveQtys(); }}>
                    {t('Derive All Qtys')}
                  </Button>

                  <BaseGrid
                    url="/api/fuse/family"
                    hasSearch
                    shouldPaginate
                    shouldUpdate={signal}
                    create={() => { setEditEntity(null); setCreateModal(!createModal); }}
                    createText={t('New Family')}
                    config={
                    {
                      columns: {
                        id: {
                          label: 'ID',
                          sort: true,
                          link: {
                            to: '/fuse/%id%',
                          },
                        },
                        name: {
                          label: 'Name',
                          sort: true,
                          link: {
                            to: '/fuse/%id%',
                          },
                        },
                        qty: { label: 'Qty', sort: true },
                        actions: {
                          label: props.t('Actions'),
                          actions: [
                            {
                              key: 'edit',
                              icon: 'mdi mdi-pencil',
                              class: 'btn btn-sm btn-soft-secondary',
                              alt: props.t('Edit'),
                              click: (ent) => {
                                setEditEntity(ent);
                                setCreateModal(true);
                              },
                            },
                            {
                              key: 'delete',
                              icon: 'mdi mdi-delete',
                              class: 'btn btn-sm btn-soft-danger',
                              alt: props.t('Delete'),
                              click: deleteFamily,
                            },
                          ],
                        },
                      },
                      pagination: {
                        sort: 'id',
                        direction: 'desc',
                        perPage: 30,
                      },
                    }
                    }
                  />
                </Can>

                <Can not i="see" this="Fuse"><p>{props.t('Unauthorized')}</p></Can>
              </CardBody>
            </Card>
          </Col>

          <Col md="6">
            <Card>
              <CardHeader className="bg-transparent border-bottom">
                {t('Properties')}
              </CardHeader>
              <CardBody>
                <Can i="see" this="Fuse">
                  <Button color="info" size="sm" className="p-1" onClick={() => { setMassModal(true); }}>
                    {t('Mass Update')}
                  </Button>
                  <BaseGrid
                    url="/api/fuse/property"
                    hasSearch
                    shouldPaginate
                    shouldUpdate={signal}
                    create={() => { setEditProp(null); setCreatePropModal(!createModal); }}
                    createText={t('New Property')}
                    config={
                    {
                      columns: {
                        id: {
                          label: 'ID',
                          sort: true,
                        },
                        label: {
                          label: 'Label',
                          sort: true,
                        },
                        tags: {
                          label: 'Tags',
                          format: (x) => (x.map((r) => (r.label))),
                          badges: {
                            class: 'bg-secondary bg-soft text-dark p-1',
                          },
                        },
                        actions: {
                          label: props.t('Actions'),
                          actions: [
                            {
                              key: 'members',
                              icon: 'mdi mdi-account-multiple',
                              class: 'btn btn-sm btn-soft-primary',
                              alt: props.t('Members'),
                              click: (ent) => {
                                setEditProp(ent);
                                setShowMembersModal(true);
                              },
                            },
                            {
                              key: 'edit',
                              icon: 'mdi mdi-pencil',
                              class: 'btn btn-sm btn-soft-secondary',
                              alt: props.t('Edit'),
                              click: (ent) => {
                                setEditProp(ent);
                                setCreatePropModal(true);
                              },
                            },
                            {
                              key: 'delete',
                              icon: 'mdi mdi-delete',
                              class: 'btn btn-sm btn-soft-danger',
                              alt: props.t('Delete'),
                              click: deleteProp,
                            },
                          ],
                        },
                      },
                      pagination: {
                        sort: 'id',
                        direction: 'desc',
                        perPage: 30,
                      },
                    }
                    }
                  />
                </Can>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Modal isOpen={massModal} size="md">
          <ModalHeader>
            {t('Mass Update Items')}
          </ModalHeader>
          <ModalBody>
            <MassUpdateForm
              onSuccess={() => { setSignal(signal + 1); setMassModal(false); }}
            />
          </ModalBody>
          <ModalFooter>
            <Button size="sm" color="link" onClick={() => { setMassModal(false); }}>
              {t('Cancel')}
            </Button>

            <Button type="submit" size="sm" color="primary" form="FuseMassUpdateForm">{editEntity ? t('Update') : t('Update')}</Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={createModal} size="lg">
          <ModalHeader>
            {t('Family Data')}
          </ModalHeader>
          <ModalBody>
            {editEntity && (
              <FamilyForm
                entity={editEntity}
                onSuccess={() => { setSignal(signal + 1); setCreateModal(false); }}
              />
            )}

            {!editEntity && (
              <FamilyForm
                onSuccess={() => { setSignal(signal + 1); setCreateModal(false); }}
              />
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="link" onClick={() => { setCreateModal(false); }}>
              {t('Cancel')}
            </Button>

            <Button type="submit" form="FuseFamilyForm">{editEntity ? t('Update') : t('Create')}</Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={createPropModal} size="lg">
          <ModalHeader>
            {t('Property Data')}
          </ModalHeader>
          <ModalBody>
            {editProp && (
              <PropertyForm
                entity={{ ...editProp, choices: editProp.choices !== '' && JSON.parse(editProp.choices) }}
                onSuccess={() => { setSignal(signal + 1); setCreatePropModal(false); }}
              />
            )}

            {!editProp && (
              <PropertyForm
                onSuccess={() => { setSignal(signal + 1); setCreatePropModal(false); }}
              />
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="link" onClick={() => { setCreatePropModal(false); }}>
              {t('Cancel')}
            </Button>

            <Button type="submit" form="FuseFamilyPropertyForm">{editProp ? t('Update') : t('Create')}</Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={showMembersModal} size="md">
          <ModalHeader>
            {t('Property Members')}
          </ModalHeader>
          <ModalBody>
            {editProp && (
              <BaseGrid
                url={`/api/fuse/property/${editProp.id}/members`}
                hasSearch
                shouldPaginate
                shouldUpdate={signal}
                config={
                {
                  columns: {
                    id: {
                      label: 'ID',
                    },
                    item: {
                      label: 'SKU',
                      format: (y, x) => {
                        if (
                          x.item
                          && x.item.linked_item !== null
                        ) {
                          return `${x.item.manufacturer} ${x.item.part_number}`;
                        }

                        return '--';
                      },
                      link: {
                        func: (x) => `/item/${x.item.id}`,
                      },
                    },
                    value: {
                      label: 'Value',
                      sort: true,
                      format: (value, member) => {
                        const choices = getPropertyChoices(editProp);

                        return createPropertyMemberValueSelect({
                          choices,
                          member,
                          onChange: setMemberProperty,
                          t,
                          value,
                        });
                      },
                    },
                    actions: {
                      label: props.t('Actions'),
                      actions: [
                        {
                          key: 'delete',
                          icon: 'mdi mdi-delete',
                          class: 'btn btn-sm btn-soft-danger',
                          alt: props.t('Delete'),
                          click: async (ent) => {
                            try {
                              if (confirm(t('Are you sure?'))) {
                                await del(`/api/fuse/property/item/${ent.item_id}/${ent.property_id}`);

                                setSignal(signal + 1);
                                toastr.success('Member deleted!', t('Success'));
                              }
                            } catch (error) {
                              toastr.error(error.message, t('Error while deleting'));
                            }
                          },
                        },
                      ],
                    },
                  },
                  pagination: {
                    sort: 'id',
                    direction: 'desc',
                    perPage: 10,
                  },
                }
                }
              />
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="link" onClick={() => { setShowMembersModal(false); }}>
              {t('Close')}
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </div>
  );
}

Fuse.defaultProps = {
  t: (x) => (x),
};

Fuse.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(Fuse));
